import React, { memo } from "react";
import { Machine, Hand, Dry } from "../common/Icon";

const Static = memo(() => {
  function ankerScroll(e) {
    document.querySelector(e).scrollIntoView({ behavior: "smooth" });
  }
  return (
    <>
      <section className="fv">
        <picture>
          <source media="(min-width:1000px)" srcSet="/material/images/fv.jpg" />
          <img src="/material/images/fv_sp.jpg" alt="" />
        </picture>
        <h1>
          Fabric & Leather <br className="sp" />
          Collection<b>生地一覧 / サンプル請求</b>
        </h1>
      </section>
      <p className="intro_text">
        NOYESは、生地選びにも妥協しません。
        <br />
        さまざまなシチュエーションを想定しながら
        <br className="sp" />
        自信を持って提供できる生地だけを厳選します。
        <br />
        表情の違う多種多様な生地の中から、
        <br className="sp" />
        お気に入りのひとつを見つけてください。
      </p>
      {/* <div style={{ textAlign: "center", marginBottom: "50px" , fontSize: "15px" , textDecoration: "underline"}}>
        <a href="https://www.ny-k.co.jp/information/topic/250718/">生地請求フォーム障害のお詫びと復旧のお知らせ</a>
      </div> */}
      <section className="anchor">
        <div>
          <img src="/material/images/fabric_label.jpg" alt="Fabric" />
          <div>
            <h3>FABRIC</h3>
            <span>
              COLLECTION<b>布生地</b>
            </span>
            <div>
              <b>ランク</b>
              <ul>
                <li>
                  <a onClick={() => ankerScroll("#F1_kiji")}>F1</a>
                </li>
                <li>
                  <a onClick={() => ankerScroll("#F2_kiji")}>F2</a>
                </li>
                <li>
                  <a onClick={() => ankerScroll("#F3_kiji")}>F3</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <img src="/material/images/leather_label.jpg?v=20260823" alt="Leather" />
          <div>
            <h3>LEATHER</h3>
            <span>
              COLLECTION<b>レザー生地</b>
            </span>
            <div>
              <b>ランク</b>
              <ul>
                {/* <li>
                  <a onClick={() => ankerScroll("#L1")}>L1</a>
                </li> */}
                <li>
                  <a onClick={() => ankerScroll("#L2_kiji")}>L2</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="link_btns">
        <a className="base_link" href="/material/narrow/pet/">
          <span>ペット対応生地から探す</span>
        </a>
        <a className="base_link" href="/material/narrow/wash/">
          <span>洗い方別で探す</span>
        </a>
      </div>

      <section className="info">
        <div>
          <b>無料生地サンプル請求</b>
          <p>
            ■選び方<br />
            各生地カラー名の横にあるチェックボックスにチェックを入れてください。
            <br />        
            <br />
            ■選び終わった後<br />
            ページ最下部の「お届け先の入力」より、生地サンプルのお届け先をご入力ください。<br />
            もしくは、サイドバーの「サンプル請求」をクリックすると、選択した生地をご確認いただけます。<br />
            内容をご確認のうえ、「お届け先の入力」へお進みください。
            <br />
            <br />
            ■1回に請求できる枚数<br />
            <b style={{ color: "#824351" }}>最大5枚まで</b>となっています。
          </p>
          <div>
            <img src="/material/images/info_sample.png" alt="" />
            {/* <b>
              実際の色味や質感を手に取ってご確認いただけます。生地選びの際にご活用ください。
            </b> */}
          </div>
        </div>
        <div>
          <div>
            <p>在庫表記</p>
            <ul>
              <li>
                <b>注</b>生地在庫が希少
              </li>
              <li>
                <b style={{ backgroundColor: "#898989" }}>無</b>生地在庫無し
              </li>
              <li>
                <small>生地在庫はおおよそ1週間単位で更新されます。</small>
              </li>
            </ul>
          </div>
          <div>
            <p>洗い方</p>
            <ul>
              <li>
                <Machine />
                洗濯機
              </li>
              <li>
                <Hand />
                手洗い
              </li>
              <li>
                <Dry />
                ドライクリーニング
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
});

export default Static;
